import { render, staticRenderFns } from "./jinsung.vue?vue&type=template&id=cb073b2a"
import script from "./jinsung.vue?vue&type=script&lang=js"
export * from "./jinsung.vue?vue&type=script&lang=js"
import style0 from "./jinsung.vue?vue&type=style&index=0&id=cb073b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports